module.exports = __webpack_public_path__ + "img/sixpackcarrier50.2c8af5ce.jpg";